"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";

export function NewStrategyCard() {
  return (
    <Link
      href="/strategies"
      className={cn(
        "rounded-xl p-4 flex flex-col items-center justify-center gap-2 min-h-[160px]",
        "transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--accent)]",
        "hover:border-[var(--border-default)]",
      )}
      style={{
        border: "1px dashed #333",
        color: "var(--text-secondary)",
      }}
      aria-label="Browse strategies to create a new one"
    >
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center"
        style={{ border: "1px solid var(--border-subtle)", background: "var(--surface-hi)" }}
        aria-hidden="true"
      >
        <span
          className="text-xl font-light leading-none"
          style={{ color: "var(--text-tertiary)" }}
        >
          +
        </span>
      </div>
      <p
        className="font-serif font-normal"
        style={{ fontSize: "0.95rem", color: "var(--text-secondary)" }}
      >
        New Strategy
      </p>
    </Link>
  );
}
